import { create } from "zustand";

export const useTableMetadataStore = create((set) => ({

	// this store is for the table metadata, like the table name, the table id, the table columns, etc.
	columns: [],
	setColumns: (columns) => set({ columns: columns }),
	addColumn: (column) => set(
		(state) => ({ columns: [...state.columns, column] }),
	),
	setColumnVisibility: (index, isVisible) => set(
		(state) => {
			return {
				columns: state.columns.map((column) => {
					if (column.index === index) {
						column.isVisible = isVisible;
					}

					return column;
				})
			}
		}
	),

	// row selection
	isRowSelectable: false,
	setIsRowSelectable: (isRowSelectable) => set({ isRowSelectable: isRowSelectable }),

	selectedRows: [],
	setSelectedRows: (selectedRows) => set({ selectedRows: selectedRows }),

	addSelectedRow: (selectedRow) => set(
		(state) => {
			// check if the row is already selected
			const selectedRowExists = state.selectedRows.find((row) => {
				return row.rowId.toString() === selectedRow.rowId.toString()
			})
			
			// if it is, then don't add it again
			if (selectedRowExists) {
				return state
			}

			return { selectedRows: [...state.selectedRows, selectedRow] }
		}
	),

	removeSelectedRow: (selectedRowId) => set(
		(state) => {
			return {
				selectedRows: state.selectedRows.filter((row) => {
					return row.rowId.toString() !== selectedRowId.toString()
				})
			}
		}
	),
	
	// the current isEditing state of the table
	isEditing: null,
	setIsEditing: (isEditing) => set({ isEditing: isEditing }),
}))
